import { IDictButtonControl } from '@infotech-soe/metaschema';

import {
  DictButtonFormControlViewModel,
  FormControlViewModelType,
} from '../../view-model/FormControlViewModel';
import { FormViewModel } from '../../view-model/FormViewModel';

import { buildCommonDictionaryButtonModel } from './helpers';

const buildDictButtonControl = async (
  item: IDictButtonControl,
  label: string,
  viewModel: FormViewModel
): Promise<DictButtonFormControlViewModel> => ({
  ...buildCommonDictionaryButtonModel(item, viewModel.source),

  columns: item.columns,
  hasHistory: false,
  hasValue: false,
  label,
  name: item.name,
  type: FormControlViewModelType.DICT_BUTTON,
  visible: item.visible,
  disabled: item.disabled,
});

export default buildDictButtonControl;
